import { createSlice } from "@reduxjs/toolkit";


export const packageDeginationSlice = createSlice({
    name: "packageDegination",
    initialState: {
        packageDeginations: [],
        edit_packageDegination_id: null,
        editingPackageDegination: null,
        loading: false,
        error: null,
    },
    reducers: {
        setLoading: (state) => {
            state.loading = true;
            state.error = null;
        },
        setPackageDeginations: (state, action) => {
            state.loading = false;
            state.error = null;
            state.packageDeginations = action.payload.data;
        },
        setError: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        addPackageDegination: (state, action) => {
            state.packageDeginations.push(action.payload);
        },
        setEditingPackageDeginationId: (state, action) => {
            state.edit_packageDegination_id = action.payload;
        },
        setEditingPackageDegination: (state, action) => {
            const packageDeginationId = action.payload;
            const packageDeginationToEdit = state.packageDeginations.find(
                (packageDegination) => packageDegination.id === packageDeginationId
            );
            if (packageDeginationToEdit) {
                state.editingPackageDegination = packageDeginationToEdit;
            }
        },
        updatePackageDegination: (state, action) => {
            const index = state.packageDeginations.findIndex(
                (packageDegination) => packageDegination.id === action.payload.id
            );
            if (index !== -1) {
                state.packageDeginations[index] = action.payload;
            }
            state.edit_packageDegination_id = null;
        }
    },
});

export const {
    setLoading,
    setPackageDeginations,
    addPackageDegination,
    setEditingPackageDeginationId,
    setError,
    setEditingPackageDegination
} = packageDeginationSlice.actions;

export default packageDeginationSlice.reducer;
